export const METRIKA_ID = 39662635
const CONSENT_COOKIE = 'cookie_consent'
const CONSENT_MAX_AGE = 60 * 60 * 24 * 365 // 12 months

export function getConsent() {
    const match = document.cookie.match(/(?:^|;\s*)cookie_consent=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : null
}

export function setConsent(value) {
    document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(value)}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`
}

let initialized = false

export function initYandexMetrika(router) {
    if (initialized || typeof window === 'undefined') return
    initialized = true

    ;(function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) }
        m[i].l = 1 * new Date()
        k = e.createElement(t)
        a = e.getElementsByTagName(t)[0]
        k.async = 1
        k.src = r
        a.parentNode.insertBefore(k, a)
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

    window.ym(METRIKA_ID, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    })

    window.ym(METRIKA_ID, 'hit', window.location.pathname + window.location.search)

    if (router) {
        router.afterEach((to) => {
            if (window.ym) window.ym(METRIKA_ID, 'hit', to.fullPath)
        })
    }
}
